import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";

const initials = (name?: string) => (name || "?").split(" ").map(p => p[0]).join("").slice(0, 2).toUpperCase();

// "A toppé" — même badge SVG que le "Vu par" des Stories, réutilisé ici pour le "Vu par" d'un
// Live (opt-in via showLikedBadge, n'affecte jamais les listes Top/Envieux/Intéressé qui n'en
// ont pas besoin puisque tout le monde dans ces listes-là a par définition réagi).
const TopStarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#0a0a0a">
    <polygon points="12 2.5 15.1 9 22 10 17 15.1 18.2 22 12 18.6 5.8 22 7 15.1 2 10 8.9 9" />
  </svg>
);

// Bottom sheet générique "qui a réagi" — réutilisé pour le Top d'une photo de galerie, pour
// Top/Envieux/Intéressé d'une publication, et pour le "Vu par" d'un Live (avec showLikedBadge).
// Même charpente que le "Vu par" des Stories.
export default function ReactorsListModal({ title, load, onClose, showLikedBadge }: {
  title: string;
  load: () => Promise<{ id: string; name: string; avatar_url?: string; liked?: boolean }[]>;
  onClose: () => void;
  showLikedBadge?: boolean;
}) {
  const navigate = useNavigate();
  const [users, setUsers] = useState<{ id: string; name: string; avatar_url?: string; liked?: boolean }[] | null>(null);

  useEffect(() => {
    load().then(setUsers).catch(() => setUsers([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Portail direct sur document.body — même bug/fix que DatePromptSheet.tsx : un position:fixed
  // descendant du conteneur mobile de Layout.tsx (WebkitOverflowScrolling:"touch") se positionne
  // sur Safari iOS par rapport au contenu défilant plutôt qu'au vrai viewport.
  return ReactDOM.createPortal(
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 5000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "18px 18px 0 0", padding: 20, width: "100%", maxWidth: 480, maxHeight: "60vh", overflowY: "auto", boxSizing: "border-box" }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>{title}</div>
        {users === null && <div style={{ fontSize: 13, color: "#999" }}>Chargement...</div>}
        {users?.length === 0 && <div style={{ fontSize: 13, color: "#999" }}>Personne pour le moment.</div>}
        {users?.map(u => (
          <div key={u.id} onClick={() => { onClose(); navigate(`/profile/${u.id}`); }} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", cursor: "pointer" }}>
            <div style={{ width: 34, height: 34, borderRadius: "50%", overflow: "hidden", backgroundColor: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: 12, fontWeight: 700, flexShrink: 0 }}>
              {u.avatar_url ? <img src={u.avatar_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : initials(u.name)}
            </div>
            <span style={{ fontSize: 13.5, fontWeight: 600, flex: 1, minWidth: 0 }}>{u.name}</span>
            {showLikedBadge && u.liked && <TopStarIcon />}
          </div>
        ))}
      </div>
    </div>
  ,
    document.body
  );
}
